import TabsWithOutlet from '../../layouts/components/TabsWithOutlet';
import React from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { DataManagementTab } from '@shared/components/data-management';
import { useConfirmation } from '@shared/components/confirmation';
import { useRemoveAdmin } from './hooks/useSystemAdmins';
import { createUniversitiesConfig } from './config/universitiesConfig';
import { createSystemAdminsConfig } from './config/systemAdminsConfig';
import { TenantRoutes } from '../tenant';
import { useBreadcrumbManager } from '../../hooks/useBreadcrumbManager';

// System admins component using the factory config
const SystemAdminsTab: React.FC = () => {
  const { confirm } = useConfirmation();
  const removeAdminMutation = useRemoveAdmin();
  const systemAdminsConfig = createSystemAdminsConfig(removeAdminMutation, confirm);

  return <DataManagementTab config={systemAdminsConfig} />;
};

// Universities component that uses the factory config with navigation
const UniversitiesTab: React.FC = () => {
  const navigate = useNavigate();
  const universitiesConfig = createUniversitiesConfig(navigate);

  return <DataManagementTab config={universitiesConfig} />;
};

export const ManageRoutes: React.FC = () => {
  // Initialize breadcrumb manager to handle tenant and domain names in nested routes
  useBreadcrumbManager();

  return (
    <Routes>
      <Route
        element={
          <TabsWithOutlet
            tabs={[
              { label: 'Universities', href: '/app/manage/universities' },
              { label: 'System Admins', href: '/app/manage/system-admins' },
            ]}
          />
        }
      >
        <Route index element={<Navigate to="/app/manage/universities" replace />} />
        <Route path="universities" element={<UniversitiesTab />} />
        <Route path="system-admins" element={<SystemAdminsTab />} />
      </Route>

      {/* Nested tenant routes */}
      <Route path="universities/:tenantId/*" element={<TenantRoutes />} />
    </Routes>
  );
};
